/**
 * @file ubc log
 * @author xujipeng
 */

/* globals getApp  getCurrentPages */
// 默认配置
const config = {
  CLICK_SERVER_ID: '11230',
  CLICK_UBC: 'clickUbc',
  SHOW_SERVER_ID: '11229',
  SHOW_UBC: 'pvUbc',
  TIMING_SERVER_ID: '12638',
  TIMING_UBC: 'timingUbc'
};
/**
 * init
 * 初始化
 *
 * @return {Object} 返回swan和h5下 ubc 对象
 */
const init = () => {
  return {
    UbcLoggerSwan: getApp().globalData.UbcLoggerSwan,
    ubcLoggerH5: getApp().globalData.UbcLoggerH5
  };
};
const getLogOptions = () => {
  const pages = getCurrentPages();
  const nowPage = pages[pages.length - 1] || {};
  return nowPage && nowPage.data && nowPage.data.logKey || {};
};

/**
 * ubc初始化
 *
 * @param {string} ubcName ubc名称
 * @param {string} serverId
 * @param {string} from 页面来源
 * @param {string} version 版本
 */
const ubcInit = (ubcName, {
  serverId,
  from = 'lvlin',
  version = '2.0'
}) => {
  const {
    UbcLoggerSwan,
    ubcLoggerH5
  } = init();
  // 可以反复init，会返回第一个
  // 不用globalData判断是否定义，是因为h5上globalData会缓存。刷新页面后会造成丢失定义
  ubcLoggerH5 && ubcLoggerH5('init', serverId, {
    from,
    version,
    source: 'h5'
  });
};
/**
 * ubc上报参数
 *
 * @param {string} page 页面名称
 * @param {string} value 事件描述信息
 * @param {string} type 事件名称
 * @param {string} client 客户端名称 mstation M站 smartapp 小程序
 * @param {Object} ext 其他参数
 */
const ubcOption = ({
  page,
  from,
  value,
  type = 'clk',
  client,
  ext = {}
}) => {
  const app = getApp();
  const logOptions = getLogOptions();
  ext = Object.assign({
    city: app.globalData.location && app.globalData.location.cityName,
    client
  }, ext, logOptions);
  return {
    scene: 'h5',
    page: logOptions.page || page,
    from: logOptions.from || from,
    value,
    type,
    ext
  };
};
// pv事件打点
export function ubcPvInit(option) {
  const {
    ubcLoggerH5,
    UbcLoggerSwan
  } = init();
  const {
    page,
    value,
    ext,
    from
  } = option;
  {
    ubcLoggerH5('secondTracker.init', config.SHOW_SERVER_ID, {
      version: '2.0',
      source: 'h5'
    });
    let sendParams = ubcOption({
      page,
      from,
      type: 'pv',
      value,
      ext,
      client: 'mstation'
    });
    ubcLoggerH5('secondTracker.event', sendParams); // eslint-disable-line
  }
}
// click事件打点
export function ubcClickInit(option) {
  const ubcName = config.CLICK_UBC;
  const {
    ubcLoggerH5
  } = init();
  const {
    page,
    value,
    ext,
    from
  } = option;
  ubcInit(ubcName, {
    serverId: config.CLICK_SERVER_ID
  });
  {
    let sendParams = ubcOption({
      page,
      from,
      type: 'clk',
      value,
      ext,
      client: 'mstation'
    });
    ubcLoggerH5('event', sendParams); // eslint-disable-line
  }
}
// show事件打点
export function sendUbcShowLog(option) {
  const ubcName = config.CLICK_UBC;
  const {
    ubcLoggerH5
  } = init();
  const {
    page,
    from,
    value,
    ext
  } = option;
  ubcInit(ubcName, {
    serverId: config.CLICK_SERVER_ID
  });
  {
    let sendParams = ubcOption({
      page,
      from,
      value,
      type: 'show',
      ext,
      client: 'mstation'
    });
    ubcLoggerH5 && ubcLoggerH5('event', sendParams);
  }
}
// timing时长打点初始化
export function sendUbcTimingInit(option) {
  const {
    ubcLoggerH5,
    UbcLoggerSwan
  } = init();
  const {
    page,
    from,
    value,
    ext
  } = option;
  // 时常打点init需要携带timingId
  ubcLoggerH5(`${config.TIMING_UBC}.init`, config.TIMING_SERVER_ID, {
    timingId: config.TIMING_SERVER_ID,
    version: '2.0',
    source: 'h5'
  });
}

/**
 *
 * timing时长事件打点（仅H5使用）
 * 需要在状态开始和结束时分别调用两次方法：
 * 1、sendUbcTimingStatus('timing', 'start', eventName, value, ext)，执行后，SDK内部会每隔3秒上报一次统计；
 * 2、sendUbcTimingStatus('timing', 'end', eventName)执行后，SDK内部会停止时间的上报。
 * 参考文档：https://console.cloud.baidu-int.com/devops/icode/repos/baidu/jady/ubc-web-sdk/tree/master
 */
export function sendUbcTimingStatus(status, option = {}) {
  const {
    ubcLoggerH5
  } = init();
  const {
    value,
    ext,
    page,
    from
  } = option;
  if (status === 'start') {
    ubcLoggerH5(`${config.TIMING_UBC}.timing`, 'start', 'timing', {
      value,
      ext,
      page,
      from
    });
  } else {
    ubcLoggerH5(`${config.TIMING_UBC}.timing`, 'end', 'timing');
  }
}
export function addKey(obj = {}) {
  delete obj.value;
  delete obj.ext;
  const pages = getCurrentPages();
  const nowPage = pages[pages.length - 1] || {};
  nowPage.data = nowPage.data || {};
  nowPage.data.logKey = nowPage.data.logKey || {};
  Object.assign(nowPage.data.logKey, obj);
}